import { Component } from '@angular/core';

@Component({
  selector: 'app-captcha-icon',
  templateUrl: './captcha-icon.component.html'
})
export class CaptchaIconComponent {

}
